import type { NodeProps } from "reactflow";
import cn from "classnames";
import { StringWaitStep, WaitStep } from "app/lib/pipeline";
import Icon from "app/components/shared/Icon";
import * as HoverCard from "app/components/Playground/HoverCard";
import BaseNode from "./BaseNode";

const WaitStepNodeIcon = () => (
  <div aria-hidden={true} className="bg-charcoal-300 p-2 rounded-lg">
    <Icon className="text-white h-6 w-6" icon="heroicons/solid/clock" />
  </div>
);

export default function WaitStepNode(
  props: NodeProps<WaitStep | StringWaitStep>,
) {
  return (
    <HoverCard.Trigger
      payload={{
        id: props.id,
        content: (
          <HoverCard.Content id={props.id} label="Wait step">
            A <em>wait</em> step waits for all previous steps to have
            successfully completed before allowing following jobs to continue.
          </HoverCard.Content>
        ),
      }}
      className="group"
    >
      <BaseNode
        {...props}
        label="Wait"
        icon={<WaitStepNodeIcon />}
        className="cursor-help group-focus:bg-gray-100 group-hover:bg-gray-100"
      />
    </HoverCard.Trigger>
  );
}
